import confimModal from "../../../../components/confirmModal";

const checkOnboarding = (loginUser, navigateCallback, address) => {
  const cancelHandler = () => {
    navigateCallback("/onboarding");
  };
  const okHandler = () => {};

  if (loginUser) {
    if (!loginUser.is_onboarded) {
      confimModal(
        "Do you want to continue without onboarding?",
        "",
        okHandler,
        cancelHandler,
      );
      return;
    } else {
      navigateCallback(address);
    }
  }
};
export default checkOnboarding;
